import React from "react";
import { t } from "i18next";
import { useNavigate } from "react-router-dom";
import { CloseOutlined, ExportOutlined, SearchOutlined } from "@ant-design/icons";
import {
  Breadcrumb,
  Button,
  Col,
  DatePicker,
  Drawer,
  Form,
  Input,
  Result,
  Row,
  Spin,
  Table,
  Select,
} from "antd";
import moment from "moment";
import { Util } from "common/util";
import { getSeniorityResigned, getSeniorityResignedExcel } from "services/payroll_report";
import { columsFirstSeniority, columsSecondSeniority } from "./helper";

const { Option } = Select;

export default function MonthlyAllocationSeniorityAndSeverancePay() {
  const [data, setData] = React.useState([]);
  const [loading, setLoading] = React.useState(false);
  const navigate = useNavigate();
  const pathName = "/reports/payroll/seniority_payment";
  const params = new URLSearchParams(document.location.search);
  const [columnTable, setColumnTable] = React.useState(columsFirstSeniority);
  let timer = null;

  const onBack = () => {
    navigate("/reports/payroll");
  };

  React.useMemo(() => {
    const params = new URLSearchParams(document.location.search);
    if (!params.get("date")) {
      params.set("date", moment().format("YYYY"));
    }

    if (!params.get("seniorityType")) {
      params.set("seniorityType", "first-seniority");
    } else {
      if (params.get("seniorityType") === "first-seniority") {
        setColumnTable(columsFirstSeniority);
      } else {
        setColumnTable(columsSecondSeniority);
      }
    }
    Util.getInstance().pushParamsToURL(pathName, params.toString());
  }, []);

  React.useEffect(() => {
    fetchList();
    // eslint-disable-next-line
  }, []);

  const fetchList = () => {
    const params = new URLSearchParams(document.location.search);
    let option = {};
    if (params.has("date")) option["date"] = params.get("date");
    if (params.has("search")) option["search"] = params.get("search");
    if (params.has("seniorityType"))
      option["seniorityType"] = params.get("seniorityType");
    setLoading(true);
    getSeniorityResigned(option)
      .then((response) => {
        if (response && Array.isArray(response)) {
          const newData = [];
          for (let res of response) {
            const temData = {
              name: res.name,
              nameKh: res.namekh,
              code: res.code,
            };

            const index =
              params.get("seniorityType") === "first-seniority" ? 1 : 7;
            const length =
              params.get("seniorityType") === "first-seniority" ? 6 : 12;

            for (let i = index; i <= length; i++) {
              const found = res.payroll.find((item) => item.month === i);
              if (found) {
                temData[`grossSalary${i}`] = found.grossSalary;
                temData[`monthly13thSalary${i}`] = found.accrualAnnualSalary;
                temData[`monthlyPFNPA${i}`] = found.accrualPFOrganization;
                temData[`payload${i}`] = found.payload;
                console.log({ temData });
              } else {
                temData[`grossSalary${i}`] = 0;
                temData[`monthly13thSalary${i}`] = 0;
                temData[`monthlyPFNPA${i}`] = 0;
                temData[`payload${i}`] = [];
              }
            }

            newData.push(temData);
          }
          setData(newData);
        }
      })
      .catch((error) => {
        if (error.response.status === 403) {
          localStorage.removeItem("ACCESS_TOKEN");
          navigate("/signin");
        }
      })
      .finally(() => setLoading(false));
  };

  const onChangeSeniorityType = (value) => {
    const params = new URLSearchParams(document.location.search);
    if (value === "first-seniority") {
      setColumnTable(columsFirstSeniority);
    } else {
      setColumnTable(columsSecondSeniority);
    }
    params.set("seniorityType", value);

    Util.getInstance().pushParamsToURL(pathName, params.toString());
    fetchList();
  };

  const onSearch = (e) => {
    clearTimeout(timer);
    const value = e.target.value;
    const params = new URLSearchParams(document.location.search);

    if (value) {
      params.set("search", value);
    } else {
      params.delete("search");
    }

    Util.getInstance().pushParamsToURL(pathName, params.toString());
    timer = setTimeout(() => {
      fetchList();
    }, 1000);
  };

  return (
    <>
      <Row style={styles.breadCream}>
        <Col span={24}>
          <Breadcrumb>
            <Breadcrumb.Item
              onClick={() => navigate("/")}
              style={{ cursor: "pointer" }}
            >
              {t("text_dashboard")}
            </Breadcrumb.Item>
            <Breadcrumb.Item onClick={onBack} style={{ cursor: "pointer" }}>
              {t("text_payroll_report")}
            </Breadcrumb.Item>
            <Breadcrumb.Item style={{ color: "#1d8747" }}>
              Total Wages & Benefits Per Semester
            </Breadcrumb.Item>
          </Breadcrumb>
        </Col>
      </Row>
      <Row style={{ padding: 15 }} id="header-report-table">
        <Col span={12}>
          <Title subTitle={"Total Wages & Benefits Per Semester"} />
        </Col>
        <Col
          span={12}
          style={{
            textAlign: "right",
            display: "flex",
            justifyContent: "flex-end",
            flexWrap: "wrap",
            gap: 10,
            paddingRight: 5,
          }}
        >
          <Input
            placeholder={t("text_search_by_employee")}
            defaultValue={params.get("search")}
            prefix={<SearchOutlined />}
            style={styles.generalSearch}
            allowClear={true}
            onChange={onSearch}
          />
          <DatePickerFilter
            fetchList={fetchList}
            pathName={pathName}
            dateFormat={"YYYY"}
            datePlaceholder={t("text_yyyy")}
            pickerDate={"year"}
          />
          <Select
            style={{ marginBottom: 0, width: 170, marginLeft: 10 }}
            valueKey="id"
            value={params.get("seniorityType")}
            onChange={(value) => onChangeSeniorityType(value)}
          >
            {[
              { id: "first-seniority", name: "First Seniority" },
              { id: "second-seniority", name: "Second Seniority" },
            ].map((value, key) => (
              <Option key={key} value={value["id"]}>
                {value["name"]}
              </Option>
            ))}
          </Select>
          <ExportButton />
        </Col>
      </Row>

      <div id="report-table1" style={{ width: `${window.innerWidth - 250}px` }}>
        <Table
          bordered
          dataSource={data}
          pagination={false}
          rowKey={(record) => `${record.name} + ${record.code} + ${Date.now()}`}
          scroll={
            data.length > 0 ? { y: window.innerHeight - 280, x: 1400 } : {}
          }
          columns={[
            {
              title: "Code",
              dataIndex: "code",
              key: "code",
              width: 100,
              fixed: "left",
            },
             {
              title: "Full Name",
              dataIndex: "name",
              key: "name",
              width: 200,
              fixed: "left",
            },
             {
              title: "Name KH",
              dataIndex: "nameKh",
              key: "nameKh",
              width: 200,
              fixed: "left",
            },
            ...columnTable,
          ]}
          loading={loading}
        />
      </div>
    </>
  );
}

function Title({ subTitle }) {
  return <span id="title-table-report">{subTitle}</span>;
}

function ExportButton() {
  const [visible, setVisible] = React.useState(false);

  const onClose = () => {
    setVisible(false);
  };

  const onShow = () => {
    setVisible(true);
  };

  return (

    <>
      <Button
        icon={<ExportOutlined />}
        onClick={onShow}
        style={{ marginLeft: 10 }}
      >
        {t("text_export")}
      </Button>
      <Drawer
        title={
          <div style={styles.headerFilter}>
            <div>{t("text_export_report")}</div>
            <div>
              <CloseOutlined onClick={onClose} />
            </div>
          </div>
        }
        placement="right"
        closable={false}
        onClose={onClose}
        visible={visible}
      >
        {visible ? <ExportExcelFile /> : null}
      </Drawer>
    </>
  );
}

const ExportExcelFile = () => {
  const [loading, setLoading] = React.useState(false);
  const params = new URLSearchParams(document.location.search);

  const onClickDownload = async () => {
    let option = {};
    if (params.has("date")) option["date"] = params.get("date");
    if (params.has("search")) option["search"] = params.get("search");
    if (params.has("seniorityType"))
      option["seniorityType"] = params.get("seniorityType");

    option["isExport"] = true;
    setLoading(true);
    try {
      const response = await getSeniorityResignedExcel(option);

      if (!response.ok) {
        throw new Error("Failed to download Excel");
      }

      const blob = await response.blob();
      const url = window.URL.createObjectURL(blob);

      const a = document.createElement("a");
      a.href = url;
      a.download = "Wages&Benefits.xlsx";
      document.body.appendChild(a);
      a.click();
      a.remove();
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download error:", error);
      alert("Failed to download Total Wages & Benefits Per Semester.");
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      {loading ? (
        <Spin
          spinning={loading}
          style={{
            height: "24vh",
            display: "flex",
            alignItems: "center",
          }}
        ></Spin>
      ) : (
        <Result
          status="success"
          title={
            "Successfully exported Total Wages & Benefits Per Semester"
          }
          extra={[
            <div style={{ marginBottom: 25 }}>
              <div
                key="1"
                className="ant-btn ant-btn-dashed"
                onClick={onClickDownload}
              >
                {t("text_download_file_xlsx")}
              </div>
            </div>,
          ]}
        />
      )}
    </>
  );
};

const DatePickerFilter = ({
  pathName,
  fetchList,
  dateFormat,
  datePlaceholder,
  pickerDate,
}) => {
  const queryParams = new URLSearchParams(document.location.search);
  const onChangeDate = (value) => {
    if (value) {
      queryParams.set("date", moment(value).format("YYYY"));
    } else {
      queryParams.delete("date");
    }
    Util.getInstance().pushParamsToURL(pathName, queryParams.toString());
    fetchList();
  };

  return (
    <>
      <Form style={{ marginLeft: "8px" }}>
        <DatePicker
          name="date"
          placeholder={`${datePlaceholder}`}
          format={`${dateFormat}`}
          style={{ marginLeft: "8px", width: "180px" }}
          defaultValue={
            queryParams.get("date") && moment(queryParams.get("date"))
          }
          picker={`${pickerDate}`}
          allowClear={false}
          onChange={onChangeDate}
        />
      </Form>
    </>
  );
};

const styles = {
  formInline: {
    width: 203,
    display: "inline-block",
    textAlign: "left",
    marginRight: 5,
    marginBottom: 0,
    marginTop: 0,
  },
  generalSearch: {
    width: 203,
  },
  headerFilter: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },
  breadCream: {
    paddingBottom: 15,
    backgroundColor: "#EFF3F6",
  },
};
